var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.36,
    height: 12.514,
    viewBox: "0 0 17.36 12.514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15178",
    "data-name": "Rectangle 15178",
    width: 17.36,
    height: 12.514,
    fill: "#0538bc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48371",
    "data-name": "Group 48371",
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48276",
    "data-name": "Group 48276",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2538",
    "data-name": "Path 2538",
    d: "M8.66,12.513q-3.2,0-6.4,0A2.21,2.21,0,0,1,.027,10.626,2.6,2.6,0,0,1,0,10.193Q0,6.247,0,2.3A2.215,2.215,0,0,1,2.3,0Q8.681,0,15.058,0a2.213,2.213,0,0,1,2.3,2.3q0,3.955,0,7.911a2.214,2.214,0,0,1-2.3,2.3q-3.2,0-6.4,0M1.212,3.337v.227c0,2.2.013,4.4-.008,6.6a1.083,1.083,0,0,0,1.138,1.141c4.226-.015,8.452-.007,12.678-.008a1.009,1.009,0,0,0,1.126-1.118q0-3.321,0-6.642c0-.065-.005-.13-.009-.215-.082.046-.137.075-.19.107q-2.928,1.752-5.857,3.5a2.574,2.574,0,0,1-2.8.013C5.8,6.069,4.316,5.18,2.826,4.294L1.212,3.337m14.9-1.376a.961.961,0,0,0-.026-.1,1.019,1.019,0,0,0-1.052-.644H2.33c-.057,0-.114,0-.17,0a1,1,0,0,0-.854.57c-.074.137-.05.213.093.3C3.532,3.34,5.667,4.6,7.79,5.872a1.529,1.529,0,0,0,1.72.008c1.854-1.112,3.717-2.208,5.577-3.31l1.021-.608",
    transform: "translate(0 0)",
    fill: "#0538bc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.7ad21f8c1a0612543608fe3e1dbe7feb.svg";
export { ForwardRef as ReactComponent };